/**
 * Proyección isométrica determinística (TKT-014).
 *
 * Convención (ADR-0006):
 *   - Tile en unidades de mundo: TILE_WIDTH × TILE_HEIGHT (en píxeles).
 *   - El plano isométrico estándar (eje "diamante") se calcula como:
 *       screenX = (world.x - world.y) * (TILE_WIDTH / 2)
 *       screenY = (world.x + world.y) * (TILE_HEIGHT / 2)
 *   - La inversa permite hit-testing y screen-to-world para cámara y debug.
 *
 * Estas funciones son puras y testeables.
 */

export interface IsoTileSize {
  width: number;
  height: number;
}

export const DEFAULT_TILE: IsoTileSize = { width: 96, height: 48 };

export interface Vec2 {
  x: number;
  y: number;
}

export function worldToScreen(world: Vec2, tile: IsoTileSize = DEFAULT_TILE): Vec2 {
  return {
    x: (world.x - world.y) * (tile.width / 2),
    y: (world.x + world.y) * (tile.height / 2),
  };
}

export function screenToWorld(screen: Vec2, tile: IsoTileSize = DEFAULT_TILE): Vec2 {
  const halfW = tile.width / 2;
  const halfH = tile.height / 2;
  return {
    x: screen.x / (2 * halfW) + screen.y / (2 * halfH),
    y: screen.y / (2 * halfH) - screen.x / (2 * halfW),
  };
}
